import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getSettings, getNews } from "@/lib/api";
import { Seo } from "@/components/site/Seo";
import { PageIntro } from "@/components/site/PageIntro";
import { NewsCard } from "@/components/site/NewsCard";

export default function News() {
  const { data: settings } = useQuery({ queryKey: ["settings"], queryFn: getSettings });
  const { data: news = [], isLoading } = useQuery({ queryKey: ["news"], queryFn: getNews });

  return (
    <>
      <Seo title="News" path="/news" settings={settings}
        description="Announcements and editorial stories from Acharya Holdings \u2014 the thinking, purpose, and progress behind the ventures we build."
        breadcrumbs={[{ name: "Home", path: "/" }, { name: "News", path: "/news" }]} />
      <PageIntro eyebrow="News" title="Announcements & stories."
        description="Corporate announcements from Acharya Holdings, alongside editorial stories exploring the thinking and purpose behind the ventures we build." />

      <div className="surface-cream">
        <section className="container-inst py-16 lg:py-24">
          {isLoading ? (
            <div className="mx-auto max-w-4xl space-y-8">
              {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="grid grid-cols-1 gap-6 sm:grid-cols-[248px_1fr]">
                  <div className="animate-pulse rounded-[10px]" style={{ background: "var(--bg-elev-1)", aspectRatio: "16 / 10" }} />
                  <div className="space-y-3">
                    <div className="h-3 w-40 animate-pulse rounded" style={{ background: "var(--bg-elev-1)" }} />
                    <div className="h-5 w-3/4 animate-pulse rounded" style={{ background: "var(--bg-elev-1)" }} />
                    <div className="h-4 w-full animate-pulse rounded" style={{ background: "var(--bg-elev-1)" }} />
                  </div>
                </div>
              ))}
            </div>
          ) : news.length === 0 ? (
            <div data-testid="news-empty-state" className="mx-auto max-w-2xl py-8 text-center">
              <p className="text-base" style={{ color: "var(--text)" }}>No announcements at this time.</p>
              <p className="mt-2 text-sm" style={{ color: "var(--muted)" }}>Updates and stories will be published here as they are released.</p>
            </div>
          ) : (
            <div data-testid="news-list" className="mx-auto max-w-4xl">
              {news.map((n) => <NewsCard key={n.id} item={n} />)}
            </div>
          )}
        </section>
      </div>
    </>
  );
}
